import { authentication } from '@microsoft/teams-js';
import { teamsPaths } from '@teams/routes/AppRoutes';
import { AuthDataPayload } from '@toggle/toggle';

interface LoginCallbacks {
  onSuccess: (authData: AuthDataPayload) => void;
  onFailure: (reason: string) => void;
}

export const useTeamsAuth = () => {
  const initiateLogin = ({ onSuccess, onFailure }: LoginCallbacks) => {
    authentication.authenticate({
      url: `${window.location.origin}${teamsPaths.authPopup}?source=teams-popup`,
      successCallback: (result?: string) => {
        if (!result) {
          onFailure('No result returned from auth popup');
          return;
        }

        try {
          const authData: AuthDataPayload = JSON.parse(result);
          onSuccess(authData);
        } catch {
          onFailure('Failed to parse auth response');
        }
      },
      failureCallback: (reason?: string) => {
        onFailure(reason ?? 'Authentication failed');
      },
    });
  };

  return { initiateLogin };
};
